import {Grid} from "@mui/material";
import {ClearFilterButton} from "../../components/filter-fields/ClearFilterButton";
import {NeighbourhoodsFilter} from "../../components/filter-fields/NeighbourhoodsFilter";
import {TextSearchFilter} from "../../components/filter-fields/TextSearchFilter";
import {filterSerializer} from "../../util/FilterSerializer";
import {andFilter, applyFilter, filterNeighbourhoods, filterText} from "../../util/FilterUtil";
import {SetState} from "../../util/FormHandlers";
import {FloorModel} from "./FloorModel";
import {INeighbourhood} from "../../api/Model";

export interface FloorsFilterForm {
    search: string;
    neighbourhoods: INeighbourhood[];
}

export const emptyFloorsFilter: FloorsFilterForm = {
    search: '',
    neighbourhoods: [],
};

export const floorsFilterSerializer = (allNeighbourhoods: INeighbourhood[]) =>
    filterSerializer<FloorsFilterForm>(emptyFloorsFilter, builder => {
        builder.neighbourhoods('neighbourhoods', allNeighbourhoods);
        builder.str('search');
    });

export function filterFloorSummaries(
    rows: readonly FloorModel[],
    filter: FloorsFilterForm,
): readonly FloorModel[] {
    return applyFilter(
        [...rows],
        andFilter(
            filterNeighbourhoods(filter.neighbourhoods, row => [...row.floorNeighbourhoods]),
            filterText(filter.search, model => [
                model.floor.name,
                ...model.floorDesks.flatMap(desk => [desk.name, desk.roomName]),
                ...model.floorEmployees.map(employee => employee.fullName),
                ...model.floorNeighbourhoods.map(neighbourhood => neighbourhood.name),
            ]),
        ),
    );
}

export function FloorsFilter({filter, setFilter, allNeighbourhoods}: {
    filter: FloorsFilterForm,
    setFilter: SetState<FloorsFilterForm>,
    allNeighbourhoods: INeighbourhood[],
}) {
    return (
        <Grid container spacing={2} alignItems="center">
            <NeighbourhoodsFilter
                filter={filter}
                setFilter={setFilter}
                allNeighbourhoods={allNeighbourhoods}
            />
            <TextSearchFilter filter={filter} setFilter={setFilter} property="search"/>
            <ClearFilterButton emptyFilter={emptyFloorsFilter} setFilter={setFilter}/>
        </Grid>
    );
}
